var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPortfolioExplorer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 268,
    height: 250,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h63v4H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h214.5v90.5H0z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "a",
    x: 0,
    y: 0,
    width: 268,
    height: 260,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1378",
    transform: "translate(-701 -1859)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(701 1859)",
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 8",
    fill: "#f2f3f4",
    stroke: "#e6e8e9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 14h228a8 8 0 0 1 8 8v228H12V22a8 8 0 0 1 8-8Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 14.5h228a7.5 7.5 0 0 1 7.5 7.5v227.5h-243V22a7.5 7.5 0 0 1 7.5-7.5Z",
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 9",
    fill: "#f7f7f7",
    stroke: "#e6e8e9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M721 1873h228a8 8 0 0 1 8 8v16H713v-16a8 8 0 0 1 8-8Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M721 1873.5h228a7.5 7.5 0 0 1 7.5 7.5v15.5h-243V1881a7.5 7.5 0 0 1 7.5-7.5Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 37",
    transform: "translate(723 1882)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 5",
    cx: 3,
    cy: 3,
    r: 3,
    fill: "#ff5552"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 6",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(8)",
    fill: "#ffb53d"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 7",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(16)",
    fill: "#00c243"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 10",
    fill: "#fff",
    stroke: "#e6e8e9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M713 1896h244v20H713z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M713.5 1896.5h243v19h-243z"
  })), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 8",
    cx: 5,
    cy: 5,
    r: 5,
    transform: "translate(723 1901)",
    fill: "#9098a4"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Repeat Grid 1",
    transform: "translate(883 1904)",
    opacity: 0.5,
    clipPath: "url(#b)",
    fill: "#9098a4"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 11",
    width: 12,
    height: 4,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 11",
    width: 12,
    height: 4,
    rx: 2,
    transform: "translate(16)"
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 11",
    width: 12,
    height: 4,
    rx: 2,
    transform: "translate(32)"
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 11",
    width: 12,
    height: 4,
    rx: 2,
    transform: "translate(48)"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 179",
    d: "M730.26 1932.22v-2.14h1.22a3.288 3.288 0 0 1 .52.04 1.21 1.21 0 0 1 .44.155.844.844 0 0 1 .3.325 1.142 1.142 0 0 1 .115.55 1.142 1.142 0 0 1-.115.55.844.844 0 0 1-.3.325 1.21 1.21 0 0 1-.44.155 3.288 3.288 0 0 1-.52.04Zm-1.57-3.36v7.14h1.57v-2.56h1.65a2.974 2.974 0 0 0 1.14-.195 2.133 2.133 0 0 0 .765-.515 1.972 1.972 0 0 0 .43-.735 2.715 2.715 0 0 0 .135-.845 2.7 2.7 0 0 0-.135-.85 1.978 1.978 0 0 0-.43-.73 2.133 2.133 0 0 0-.765-.515 2.974 2.974 0 0 0-1.14-.195Zm7.78 4.56a3.1 3.1 0 0 1 .06-.61 1.556 1.556 0 0 1 .205-.53 1.151 1.151 0 0 1 .385-.38 1.143 1.143 0 0 1 .6-.145 1.17 1.17 0 0 1 .6.145 1.137 1.137 0 0 1 .39.375 1.556 1.556 0 0 1 .2.53 3.1 3.1 0 0 1 .06.61 3.028 3.028 0 0 1-.06.6 1.612 1.612 0 0 1-.2.53 1.079 1.079 0 0 1-.39.375 1.2 1.2 0 0 1-.6.14 1.175 1.175 0 0 1-.6-.14 1.092 1.092 0 0 1-.385-.375 1.612 1.612 0 0 1-.205-.53 3.028 3.028 0 0 1-.06-.595Zm-1.42 0a3.133 3.133 0 0 0 .19 1.12 2.43 2.43 0 0 0 .54.855 2.362 2.362 0 0 0 .84.545 3.022 3.022 0 0 0 1.1.19 3.062 3.062 0 0 0 1.1-.19 2.353 2.353 0 0 0 .845-.545 2.43 2.43 0 0 0 .54-.855 3.133 3.133 0 0 0 .19-1.12 3.174 3.174 0 0 0-.185-1.12 2.421 2.421 0 0 0-.54-.86 2.41 2.41 0 0 0-.845-.55 2.992 2.992 0 0 0-1.1-.2 2.953 2.953 0 0 0-1.1.2 2.42 2.42 0 0 0-.84.55 2.421 2.421 0 0 0-.54.86 3.174 3.174 0 0 0-.195 1.12Zm6.27-2.59v5.17h1.42v-2.33a2.858 2.858 0 0 1 .07-.65 1.423 1.423 0 0 1 .235-.525 1.143 1.143 0 0 1 .435-.355 1.513 1.513 0 0 1 .66-.13 2.536 2.536 0 0 1 .27.015q.14.015.24.035v-1.32a1.107 1.107 0 0 0-.31-.05 1.7 1.7 0 0 0-.52.08 1.906 1.906 0 0 0-.47.225 1.769 1.769 0 0 0-.39.35 1.746 1.746 0 0 0-.27.445h-.02v-.96Zm5.69 0v-1.55h-1.42v1.55h-.86v.95h.86v3.05a1.321 1.321 0 0 0 .13.63.926.926 0 0 0 .355.37 1.474 1.474 0 0 0 .52.175 4.145 4.145 0 0 0 .625.045q.21 0 .43-.01a3.379 3.379 0 0 0 .4-.04v-1.1a1.989 1.989 0 0 1-.21.03q-.11.01-.23.01a.7.7 0 0 1-.48-.12.7.7 0 0 1-.12-.48v-2.56h1.04v-.95Zm2.03.95v4.22h1.42v-4.22h.98v-.95h-.98v-.31a.663.663 0 0 1 .125-.455.545.545 0 0 1 .415-.135 4.364 4.364 0 0 1 .52.03v-1.06q-.18-.01-.37-.025t-.38-.015a1.742 1.742 0 0 0-1.3.44 1.549 1.549 0 0 0-.43 1.13v.4h-.85v.95Zm4.28 1.64a3.1 3.1 0 0 1 .06-.61 1.556 1.556 0 0 1 .2-.53 1.151 1.151 0 0 1 .39-.38 1.143 1.143 0 0 1 .6-.145 1.17 1.17 0 0 1 .605.145 1.137 1.137 0 0 1 .39.375 1.556 1.556 0 0 1 .2.53 3.1 3.1 0 0 1 .06.61 3.028 3.028 0 0 1-.06.6 1.612 1.612 0 0 1-.2.53 1.079 1.079 0 0 1-.39.375 1.2 1.2 0 0 1-.605.14 1.175 1.175 0 0 1-.6-.14 1.092 1.092 0 0 1-.385-.375 1.612 1.612 0 0 1-.2-.53 3.028 3.028 0 0 1-.065-.595Zm-1.42 0a3.133 3.133 0 0 0 .19 1.12 2.43 2.43 0 0 0 .54.855 2.362 2.362 0 0 0 .84.545 3.022 3.022 0 0 0 1.1.19 3.062 3.062 0 0 0 1.1-.19 2.353 2.353 0 0 0 .845-.545 2.43 2.43 0 0 0 .54-.855 3.133 3.133 0 0 0 .19-1.12 3.174 3.174 0 0 0-.185-1.12 2.421 2.421 0 0 0-.54-.86 2.41 2.41 0 0 0-.845-.55 2.992 2.992 0 0 0-1.1-.2 2.953 2.953 0 0 0-1.1.2 2.42 2.42 0 0 0-.84.55 2.421 2.421 0 0 0-.54.86 3.174 3.174 0 0 0-.195 1.12Zm6.31-4.56v7.14h1.42v-7.14Zm4 1.17v-1.17h-1.42v1.17Zm-1.42.8v5.17h1.42v-5.17Zm3.8 2.59a3.1 3.1 0 0 1 .06-.61 1.556 1.556 0 0 1 .2-.53 1.151 1.151 0 0 1 .39-.38 1.143 1.143 0 0 1 .6-.145 1.17 1.17 0 0 1 .6.145 1.137 1.137 0 0 1 .39.375 1.556 1.556 0 0 1 .205.53 3.1 3.1 0 0 1 .06.61 3.028 3.028 0 0 1-.06.6 1.612 1.612 0 0 1-.205.53 1.079 1.079 0 0 1-.39.375 1.2 1.2 0 0 1-.6.14 1.175 1.175 0 0 1-.6-.14 1.092 1.092 0 0 1-.385-.375 1.612 1.612 0 0 1-.2-.53 3.028 3.028 0 0 1-.065-.595Zm-1.42 0a3.133 3.133 0 0 0 .19 1.12 2.43 2.43 0 0 0 .54.855 2.362 2.362 0 0 0 .84.545 3.022 3.022 0 0 0 1.1.19 3.062 3.062 0 0 0 1.1-.19 2.353 2.353 0 0 0 .845-.545 2.43 2.43 0 0 0 .54-.855 3.133 3.133 0 0 0 .19-1.12 3.174 3.174 0 0 0-.185-1.12 2.421 2.421 0 0 0-.54-.86 2.41 2.41 0 0 0-.845-.55 2.992 2.992 0 0 0-1.1-.2 2.953 2.953 0 0 0-1.1.2 2.42 2.42 0 0 0-.84.55 2.421 2.421 0 0 0-.54.86 3.174 3.174 0 0 0-.195 1.12Zm9.2-4.56v7.14h5.42v-1.32h-3.85v-1.75h3.46v-1.22h-3.46v-1.53h3.77v-1.32Zm7.65 4.42-1.86 2.72h1.59l1.08-1.63 1.08 1.63h1.62l-1.91-2.75 1.7-2.42h-1.57l-.9 1.35-.91-1.35h-1.62Zm6.66 1.79a1.132 1.132 0 0 1-.58-.14 1.123 1.123 0 0 1-.385-.365 1.576 1.576 0 0 1-.21-.525 2.873 2.873 0 0 1-.065-.61 3.154 3.154 0 0 1 .06-.62 1.556 1.556 0 0 1 .2-.53 1.167 1.167 0 0 1 .38-.375 1.1 1.1 0 0 1 .585-.145 1.075 1.075 0 0 1 .575.145 1.2 1.2 0 0 1 .385.38 1.624 1.624 0 0 1 .215.535 2.872 2.872 0 0 1 .065.61 3.1 3.1 0 0 1-.06.61 1.5 1.5 0 0 1-.2.525 1.138 1.138 0 0 1-.38.365 1.126 1.126 0 0 1-.585.14Zm-2.61-4.24v6.98h1.42v-2.45h.02a1.675 1.675 0 0 0 .665.575 2.013 2.013 0 0 0 .885.195 2.136 2.136 0 0 0 1-.22 2.106 2.106 0 0 0 .71-.59 2.546 2.546 0 0 0 .425-.85 3.553 3.553 0 0 0 .14-1 3.931 3.931 0 0 0-.14-1.055 2.576 2.576 0 0 0-.43-.885 2.168 2.168 0 0 0-.73-.61 2.239 2.239 0 0 0-1.05-.23 2.025 2.025 0 0 0-.88.19 1.562 1.562 0 0 0-.66.61h-.02v-.66Zm6.15-1.97v7.14h1.42v-7.14Zm3.8 4.56a3.1 3.1 0 0 1 .06-.61 1.556 1.556 0 0 1 .205-.53 1.151 1.151 0 0 1 .385-.38 1.143 1.143 0 0 1 .6-.145 1.17 1.17 0 0 1 .6.145 1.137 1.137 0 0 1 .39.375 1.556 1.556 0 0 1 .205.53 3.1 3.1 0 0 1 .06.61 3.028 3.028 0 0 1-.06.6 1.612 1.612 0 0 1-.205.53 1.079 1.079 0 0 1-.39.375 1.2 1.2 0 0 1-.6.14 1.175 1.175 0 0 1-.6-.14 1.092 1.092 0 0 1-.385-.375 1.612 1.612 0 0 1-.205-.53 3.028 3.028 0 0 1-.06-.595Zm-1.42 0a3.133 3.133 0 0 0 .19 1.12 2.43 2.43 0 0 0 .54.855 2.362 2.362 0 0 0 .84.545 3.022 3.022 0 0 0 1.1.19 3.062 3.062 0 0 0 1.1-.19 2.353 2.353 0 0 0 .845-.545 2.43 2.43 0 0 0 .54-.855 3.133 3.133 0 0 0 .19-1.12 3.174 3.174 0 0 0-.185-1.12 2.421 2.421 0 0 0-.54-.86 2.41 2.41 0 0 0-.845-.55 2.992 2.992 0 0 0-1.1-.2 2.953 2.953 0 0 0-1.1.2 2.42 2.42 0 0 0-.84.55 2.421 2.421 0 0 0-.54.86 3.174 3.174 0 0 0-.195 1.12Zm6.27-2.59v5.17h1.42v-2.33a2.857 2.857 0 0 1 .07-.65 1.423 1.423 0 0 1 .24-.52 1.143 1.143 0 0 1 .435-.355 1.513 1.513 0 0 1 .66-.13 2.536 2.536 0 0 1 .27.015q.14.015.24.035v-1.325a1.107 1.107 0 0 0-.31-.05 1.7 1.7 0 0 0-.52.08 1.906 1.906 0 0 0-.47.225 1.769 1.769 0 0 0-.39.35 1.746 1.746 0 0 0-.27.445h-.02v-.96Zm7.19 2.03h-2.31a1.63 1.63 0 0 1 .065-.34 1.044 1.044 0 0 1 .185-.36 1.076 1.076 0 0 1 .36-.285 1.235 1.235 0 0 1 .565-.115 1 1 0 0 1 .775.28 1.641 1.641 0 0 1 .36.82Zm-2.31.9h3.73a3.65 3.65 0 0 0-.1-1.15 2.815 2.815 0 0 0-.455-.98 2.3 2.3 0 0 0-.805-.685 2.458 2.458 0 0 0-1.15-.255 2.678 2.678 0 0 0-1.07.21 2.542 2.542 0 0 0-.835.575 2.534 2.534 0 0 0-.54.865 3.015 3.015 0 0 0-.19 1.08 3.148 3.148 0 0 0 .185 1.1 2.5 2.5 0 0 0 .525.86 2.287 2.287 0 0 0 .83.555 2.953 2.953 0 0 0 1.1.195 2.708 2.708 0 0 0 1.5-.4 2.373 2.373 0 0 0 .92-1.33h-1.255a.892.892 0 0 1-.38.455 1.266 1.266 0 0 1-.74.215 1.269 1.269 0 0 1-.92-.31 1.436 1.436 0 0 1-.35-1Zm4.57-2.93v5.17h1.42v-2.33a2.857 2.857 0 0 1 .07-.65 1.423 1.423 0 0 1 .235-.525 1.143 1.143 0 0 1 .435-.355 1.513 1.513 0 0 1 .66-.13 2.536 2.536 0 0 1 .27.015q.14.015.24.035v-1.32a1.107 1.107 0 0 0-.31-.05 1.7 1.7 0 0 0-.52.08 1.906 1.906 0 0 0-.47.225 1.769 1.769 0 0 0-.39.35 1.746 1.746 0 0 0-.27.445h-.02v-.96Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 25",
    fill: "none",
    stroke: "#e6e8e9",
    d: "M727.5 1947.5h214"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1373",
    transform: "translate(89.442 -1072)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 1583",
    transform: "translate(765.558 2996)",
    fill: "#fff",
    stroke: "#a6acb6"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 87,
    height: 16,
    rx: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 86,
    height: 15,
    rx: 3.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 1584",
    width: 51,
    height: 4,
    rx: 1,
    transform: "translate(772.558 3002)",
    fill: "#9098a4",
    opacity: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1376"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 1545",
    fill: "#fff",
    d: "M728 1967h214v47H728z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 27",
    fill: "none",
    stroke: "#e6e8e9",
    d: "M727.5 1967h214"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1375",
    transform: "translate(0 -21)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1374"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1260",
    transform: "translate(-116 249)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 1542",
    width: 58,
    height: 8,
    rx: 2,
    transform: "translate(856 1770)",
    fill: "#c7cbd1",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 1546",
    width: 20,
    height: 4,
    rx: 1,
    transform: "translate(856 1763)",
    fill: "#9098a4",
    opacity: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1260",
    transform: "translate(-50 249)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 1542",
    width: 58,
    height: 8,
    rx: 2,
    transform: "translate(856 1770)",
    fill: "#c7cbd1",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 1546",
    width: 20,
    height: 4,
    rx: 1,
    transform: "translate(856 1763)",
    fill: "#9098a4",
    opacity: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1260",
    transform: "translate(16 249)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 1542",
    width: 58,
    height: 8,
    rx: 2,
    transform: "translate(856 1770)",
    fill: "#c7cbd1",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 1546",
    width: 20,
    height: 4,
    rx: 1,
    transform: "translate(856 1763)",
    fill: "#9098a4",
    opacity: 0.8
  }))), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 1547",
    width: 97,
    height: 6,
    rx: 1,
    transform: "translate(750 1997)",
    fill: "#9098a4",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 178",
    d: "M743 1996a4 4 0 1 1-4 4 4 4 0 0 1 4-4Z",
    fill: "#fd0826"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Repeat Grid 25",
    transform: "translate(727.5 2018.5)",
    clipPath: "url(#c)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1377"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 1545",
    fill: "#fff",
    d: "M.5.5h214v47H.5z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 27",
    fill: "none",
    stroke: "#e6e8e9",
    d: "M0 .5h214"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1375",
    transform: "translate(-727.5 -1987.5)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1374"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1260",
    transform: "translate(-116 249)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 1542",
    width: 58,
    height: 8,
    rx: 2,
    transform: "translate(856 1770)",
    fill: "#c7cbd1",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 1546",
    width: 20,
    height: 4,
    rx: 1,
    transform: "translate(856 1763)",
    fill: "#9098a4",
    opacity: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1260",
    transform: "translate(-50 249)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 1542",
    width: 58,
    height: 8,
    rx: 2,
    transform: "translate(856 1770)",
    fill: "#c7cbd1",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 1546",
    width: 20,
    height: 4,
    rx: 1,
    transform: "translate(856 1763)",
    fill: "#9098a4",
    opacity: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1260",
    transform: "translate(16 249)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 1542",
    width: 58,
    height: 8,
    rx: 2,
    transform: "translate(856 1770)",
    fill: "#c7cbd1",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 1546",
    width: 20,
    height: 4,
    rx: 1,
    transform: "translate(856 1763)",
    fill: "#9098a4",
    opacity: 0.8
  }))), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 1547",
    width: 97,
    height: 6,
    rx: 1,
    transform: "translate(750 1997)",
    fill: "#9098a4",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 178",
    d: "M743 1996a4 4 0 1 1-4 4 4 4 0 0 1 4-4Z",
    fill: "#a6adb6"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1377"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 1545",
    fill: "#fff",
    d: "M.5 52.5h214v47H.5z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 27",
    fill: "none",
    stroke: "#e6e8e9",
    d: "M0 52.5h214"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1375",
    transform: "translate(-727.5 -1935.5)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1374"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1260",
    transform: "translate(-116 249)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 1542",
    width: 58,
    height: 8,
    rx: 2,
    transform: "translate(856 1770)",
    fill: "#c7cbd1",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 1546",
    width: 20,
    height: 4,
    rx: 1,
    transform: "translate(856 1763)",
    fill: "#9098a4",
    opacity: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1260",
    transform: "translate(-50 249)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 1542",
    width: 58,
    height: 8,
    rx: 2,
    transform: "translate(856 1770)",
    fill: "#c7cbd1",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 1546",
    width: 20,
    height: 4,
    rx: 1,
    transform: "translate(856 1763)",
    fill: "#9098a4",
    opacity: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1260",
    transform: "translate(16 249)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 1542",
    width: 58,
    height: 8,
    rx: 2,
    transform: "translate(856 1770)",
    fill: "#c7cbd1",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 1546",
    width: 20,
    height: 4,
    rx: 1,
    transform: "translate(856 1763)",
    fill: "#9098a4",
    opacity: 0.8
  }))), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 1547",
    width: 97,
    height: 6,
    rx: 1,
    transform: "translate(750 1997)",
    fill: "#9098a4",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 178",
    d: "M743 1996a4 4 0 1 1-4 4 4 4 0 0 1 4-4Z",
    fill: "#a6adb6"
  })))), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 1606",
    width: 214,
    height: 14,
    rx: 1,
    transform: "translate(728 1948)",
    fill: "#d2d5da"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPortfolioExplorer);
export default __webpack_public_path__ + "static/media/portfolio-explorer.b4ca7d5feb63d5c670707a96f9b921fd.svg";
export { ForwardRef as ReactComponent };